import { makeStyles } from '@material-ui/core'

export const useFormStyles = makeStyles(theme => ({
  root: {
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  label: {
    fontWeight: 500,
    fontSize: 14
  },
  button: {height: 40, borderRadius: 8, fontSize: 14},
  autoselect: {
    padding: 0,
    fontSize: 12,
    '& .MuiInputBase-input': {
      paddingRight: 50
    }
  },
  dotsContainer: {
    display: 'flex',
    gap: 4,
    fontSize: 8,
    alignItems: 'center'
  }
}))